/**********************************

  worldpantry-inventory.js   (EIGHT O'CLOCK COFFEE)

  Cookie helpers + self-heal + polling auto-trigger + live product-inventory
  functions.

  ZIP ACQUISITION: assets/worldpantry-ipzipcode.js (the boss's app-proxy
  file) sets the `zipcode` cookie. The old inline IPStack call and its
  EXPOSED access_key (and the insecure http:// endpoint) have been REMOVED.

  WHY POLLING: ipzipcode.js sets the cookie from an async fetch with no
  event, so a one-shot read on ready loses the race on a cold visit. The
  poller watches for the cookie, fires the lookup once a VALID zip lands,
  and gives up at a ceiling.

  AUTO-TRIGGER + BUTTON: the shipping form is now a DIV with a
  <button type="button"> (the shared panel), not a <form>. The auto-trigger
  fills the zip input and CLICKS the button (the shared logic listens for
  that click) -- it does NOT call .submit() (a div has no submit event).

  LOAD ORDER: requires jQuery, loaded AFTER the jQuery tags.

  Shipping submit/display logic lives in snippets/worldpantry-fast-shipping-logic.liquid.

***********************************/

/* ============================================================
   CONFIG -- per-site values. Inventory endpoint key is uppercase
   WP_2022_EIGHTOCLOCK; the fast-ship key (in the logic snippet) is
   lowercase wp_2022_eightoclock. Copied VERBATIM -- do not normalise.
   ============================================================ */
var WP_INV = {
  endpointKey: 'WP_2022_EIGHTOCLOCK',
  inventoryUrlSingle: 'https://shop.worldpantry.com/productinventories/eightoclock/productinventory.aspx',
  inventoryUrlBatch:  'https://shop.worldpantry.com/productinventories/eightoclock/productinventories.aspx',

  cookies: {
    zip:       'zipcode',
    fsZip:     'FastShip.ZipCode',
    receiveBy: 'FastShip.ReceiveByDateTime',
    orderBy:   'FastShip.OrderByDateTime',
    calcError: 'FastShip.FastShipCalculationError'
  },

  // Auto-trigger hooks. The form is a DIV.js-fs-form with .zip_input / .zip_button.
  zipInputSelector:  '.zip_input',
  containerSelector: '.js-fs-form',
  buttonSelector:    '.zip_button',

  // Polling ceiling for the async proxy zip.
  pollIntervalMs: 250,
  pollMaxTicks:   40,   // 40 * 250ms = 10s

  // EOC status string (preserved verbatim).
  outOfStockDisplay: 'Usually ships within 30 days'
};

/**********************************
  Cookie functions
***********************************/
function setSessionCookie(name, value) {
  document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; SameSite=Strict; Secure";
}

function getSessionCookie(name) {
  const nameKey = name + "=";
  const cArr = document.cookie.split('; ');
  let res;
  cArr.forEach(val => {
    if (val.indexOf(nameKey) === 0) res = decodeURIComponent(val.substring(nameKey.length));
  });
  return res;
}

function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Strict; Secure";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  var result = null;
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) result = decodeURIComponent(c.substring(nameEQ.length));
  }
  return result;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  var encodedValue = value != null ? encodeURIComponent(value) : "";
  document.cookie = name + "=" + encodedValue + expires + "; path=/; SameSite=Strict; Secure";
}

function isValidZip(str) {
  return /^\d{5}(-\d{4})?$/.test(str || "");
}

/**********************************
  One-time self-heal for a stuck error banner / legacy non-ISO dates.
***********************************/
(function selfHealFastShipCookies() {
  var err = getSessionCookie(WP_INV.cookies.calcError);
  if (err) {
    var zip = getSessionCookie(WP_INV.cookies.fsZip);
    if (err === "No Error" || !isValidZip(zip)) {
      deleteCookie(WP_INV.cookies.calcError);
    }
  }
  var receiveBy = getSessionCookie(WP_INV.cookies.receiveBy);
  var orderBy = getSessionCookie(WP_INV.cookies.orderBy);
  if ((receiveBy && isNaN(new Date(receiveBy))) ||
      (orderBy && isNaN(new Date(orderBy)))) {
    deleteCookie(WP_INV.cookies.receiveBy);
    deleteCookie(WP_INV.cookies.orderBy);
  }
})();

/**********************************
  Auto-trigger (POLLING). Fires the lookup once a VALID zip cookie lands,
  by filling the zip input and CLICKING the panel's button. Guarded to one
  lookup per page.
***********************************/
$(document).ready(function () {
  if (window.wpZipAutoTriggered) return;

  var ticks = 0;

  function fireLookup(zip) {
    window.wpZipAutoTriggered = true;
    console.log("fast geo zip " + zip);
    var $container = $(WP_INV.containerSelector).first();
    if (!$container.length) return;
    $container.find(WP_INV.zipInputSelector).val(zip);
    $container.find(WP_INV.buttonSelector).first().trigger('click');
  }

  var existing = getCookie(WP_INV.cookies.zip);
  if (isValidZip(existing)) {
    fireLookup(existing);
    return;
  }

  var poll = setInterval(function () {
    ticks++;
    var zip = getCookie(WP_INV.cookies.zip);
    if (isValidZip(zip)) {
      clearInterval(poll);
      fireLookup(zip);
      return;
    }
    if (ticks >= WP_INV.pollMaxTicks) {
      clearInterval(poll);
      console.log("no valid zipcode after polling - manual entry only");
    }
  }, WP_INV.pollIntervalMs);
});

/**********************************
  Product Inventory functions (preserved from the original EOC file).
  Keys copied VERBATIM (WP_2022_EIGHTOCLOCK). Metafields are capitalized
  on this store (Product_number / Variant_number) -- the PDP snippet reads
  them with that exact case.
***********************************/
const OutOfStockAlwaysSellStatusDisplay = WP_INV.outOfStockDisplay;

function getProductInventoryDisplay(zip, productId, variantId, setProductInventoryStatus) {
  var postproductinventory = $.post(WP_INV.inventoryUrlSingle, {
    zip: zip, key: WP_INV.endpointKey, productid: productId, variantid: variantId
  });
  postproductinventory.done(function (data) {
    if (data) {
      if (data.Status == 'OutOfStock' || data.Status == 'AlwaysSell') {
        data.StatusDisplay = OutOfStockAlwaysSellStatusDisplay;
      }
      setProductInventoryStatus(data);
    }
  });
}

function getProductNumbers() {
  var productNumbers;
  $.ajax({ type: 'GET', url: '/cart?view=wp-productnumbers', async: false })
    .done(function (response) { productNumbers = JSON.parse(response); });
  return productNumbers;
}

function getProductInventories(productNumbers) {
  var items = [];
  var productInventories;
  for (var i = 0; i < productNumbers.length; i++) {
    var item = {};
    item["productId"] = productNumbers[i].productNumber;
    item["variantId"] = productNumbers[i].variantNumber;
    items.push(item);
  }

  if (items) {
    var shippingInfo = new Object();
    shippingInfo.zip = getCookie('zipcode');
    shippingInfo.items = items;
    $.ajax({
      type: "POST",
      url: WP_INV.inventoryUrlBatch,
      data: { key: WP_INV.endpointKey, shippingInfo: JSON.stringify(shippingInfo) },
      async: false
    }).done(function (data) { productInventories = data; });
  }
  return productInventories;
}

/* Async variant used by the modernized PDP inventory snippet (no
   main-thread block). */
function getProductInventoriesAsync(productNumbers, callback) {
  var items = [];
  for (var i = 0; i < productNumbers.length; i++) {
    items.push({
      productId: productNumbers[i].productNumber,
      variantId: productNumbers[i].variantNumber
    });
  }
  if (!items.length) { callback(null); return; }

  var shippingInfo = { zip: getCookie('zipcode'), items: items };
  $.ajax({
    type: "POST",
    url: WP_INV.inventoryUrlBatch,
    data: { key: WP_INV.endpointKey, shippingInfo: JSON.stringify(shippingInfo) }
  })
    .done(function (data) { callback(data); })
    .fail(function () { console.log("inventory lookup failed"); callback(null); });
}

function showProductInventoryCartStatusDisplay(productInventories) {
  var showInventoryCartStatusDisplay = false;
  if (productInventories) {
    for (var i = 0; i < productInventories.length; i++) {
      if (productInventories[i].Status == 'AlwaysSell' || productInventories[i].Status == 'OutOfStock') {
        showInventoryCartStatusDisplay = true;
        break;
      }
    }
  }
  return showInventoryCartStatusDisplay;
}

/* Guarded: skips records with a missing ProductId/VariantId rather than
   throwing on .toUpperCase() of undefined. */
function getProductInventory(id, productNumbers, productInventories) {
  var inventoryStatus;
  for (var n = 0; n < productNumbers.length; n++) {
    if (productNumbers[n].id == id) {
      var productNumber = productNumbers[n].productNumber;
      var variantNumber = productNumbers[n].variantNumber;
      for (var i = 0; i < productInventories.length; i++) {
        if (productInventories[i].ProductId &&
            productInventories[i].VariantId &&
            productInventories[i].ProductId.toUpperCase() == productNumber.toUpperCase() &&
            productInventories[i].VariantId.toUpperCase() == variantNumber.toUpperCase()) {
          inventoryStatus = productInventories[i];
          if (inventoryStatus.Status == 'OutOfStock' || inventoryStatus.Status == 'AlwaysSell') {
            inventoryStatus.StatusDisplay = OutOfStockAlwaysSellStatusDisplay;
          }
          break;
        }
      }
      break;
    }
  }
  return inventoryStatus;
}
